<template>
  <div class="dialog-body">
    <el-dialog title="打印设置" :visible.sync="dialogVisible" append-to-body width="60%" center>
      <div class="formClass">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="dialogFormRef"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="打印费用：" prop="typeList">
            <el-checkbox-group v-model="ruleForm.typeList">
              <el-checkbox
                v-for="item in costItem"
                :key="item.value"
                :label="item.value"
                name="type"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="打印日期：" prop="printDate">
                <el-date-picker
                  placeholder="选择日期"
                  v-model="ruleForm.printDate"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="打印人：" prop="printName">
                <search-table
                  v-model="ruleForm.printName"
                  searchType="personnel"
                  :currentValue="ruleForm.printName"
                  :isMultiple="true"
                  :extraData="{
                    personCompanyCode: userInfo.companyCode,
                  }"
                  @input="(v) => slectInvoiceUnitNo(v)"
                ></search-table>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="公司名称" prop="companyCode">
                <el-select @change="personCompany" v-model="ruleForm.companyCode">
                  <el-option
                    v-for="(item, index) in departmentList"
                    :key="index"
                    :value="item.personCompanyCode"
                    :label="item.personCompanyName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item disabled label="开户行" prop="payBranchCode">
                <search-table
                  v-model="ruleForm.payBranchCode"
                  placeholder="请选择付款行"
                  searchType="bankCompany"
                  @input="changePayBank"
                  :isMultiple="true"
                  :extraData="extraData"
                ></search-table>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="账号" prop="bankAccountNum">
                <input type="text" class="bank-style" v-model="ruleForm.bankAccountNum" disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="打印说明：">
            <el-input type="textarea" v-model="ruleForm.printDesc"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleSure">确认打印</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import API from '@/api/masterData/company.js';
  import moment from 'moment';
  import ReportMixin from './mixins/reportMixin';
  export default {
    name: 'printSetup',
    mixins: [ReportMixin],
    components: {},
    props: {
      searchData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        dialogVisible: false,
        dialogData: [],
        departmentList: [],
        extraData: {
          companyCode: null,
        },
        ruleForm: {
          printDate: '',
          printName: '',
          typeList: ['01', '02', '03'],
          printDesc: '',
          branchName: null,
          bankAccountNum: null,
          companyCode: null,
          payBranchCode: null,
        },
        costItem: [
          {
            name: '租金',
            value: '01',
          },
          {
            name: '物业费',
            value: '02',
          },
          {
            name: '水电费',
            value: '03',
          },
        ],
        rules: {
          printName: [{ required: true, message: '请选择打印人', trigger: 'change' }],
          printDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
          typeList: [
            { type: 'array', required: true, message: '请至少选择一个打印费用', trigger: 'change' },
          ],
          companyCode: [{ required: true, message: '请选择公司名称', trigger: 'change' }],
          bankAccountNum: [{ required: true, message: '请选择账号', trigger: 'change' }],
          payBranchCode: [{ required: true, message: '请选择开户行', trigger: 'change' }],
        },
      };
    },
    mounted() {
      this.ruleForm.printDate = moment(new Date()).format('YYYY-MM-DD');
      this.ruleForm.printDesc =
        '请业主于当月15日前交清以上款项，逾期我司将从当月15日始按欠款总额每日万分之六计收违约金。若费用拖欠至30天的，我司有权停供水电。';
      this.ruleForm.printName = this.userInfo.userName;
      this.ruleForm.companyCode = this.userInfo.companyCode;
      this.ruleForm.companyName = this.userInfo.companyName;
      this.extraData.companyCode = this.userInfo.companyCode;
      this.department(this.userInfo.companyCode);
    },
    methods: {
      changePayBank(e) {
        console.log(e, e[0], '银行');
        this.ruleForm.bankAccountNum = e[0].bankAccountNum;
        this.ruleForm.branchName = e[0].branchName;
      },
      personCompany(value) {
        this.extraData.companyCode = value;
        this.departmentList.forEach((item) => {
          if (item.personCompanyCode == value) {
            this.ruleForm.companyName = item.personCompanyName;
          }
        });
        console.log(value, this.departmentList, this.departmentList[value], '公司切换');
      },
      async openDialog(data) {
        this.ruleForm.printDate = moment(new Date()).format('YYYY-MM-DD');
        this.ruleForm.printName = this.userInfo.userName;
        this.dialogVisible = true;
        this.dialogData = [];
        data.forEach((item) => {
          this.dialogData.push(item.contractNo);
        });
      },
      slectInvoiceUnitNo(e) {
        let data = e[0];
        this.ruleForm.printName = data.personName;
      },
      handleClose() {
        this.dialogVisible = false;
        // this.ruleForm.branchName = null;
        // this.extraData.companyCode = null;
        console.log('关闭', this.ruleForm, this.extraData);
        this.$refs.dialogFormRef.resetFields();
        this.$emit('handleSure');
      },
      handleSure() {
        this.$refs.dialogFormRef.validate(async (valid) => {
          if (valid) {
            let params = {
              ...this.searchData,
              ...this.ruleForm,
            };
            params.spaceAssetId = params.spaceAssetId ? params.spaceAssetId.split(',') : [];
            params.contractNo = this.dialogData;
            this.company(params);
          }
        });
      },
      company(params) {
        this.$axios
          .get(API.GET_COMPANY_DETAIL_API + '/' + this.searchData.contractCompanyNo)
          .then((res) => {
            if (0 == res.data.code) {
              let createCompanyName = res.data.data.company.createCompanyName;
              params.createCompanyName = createCompanyName;
              // this.$router.push({
              //   name: `print`,
              //   params: params,
              // });
              let obj = {
                params: JSON.stringify(params),
                access_token: this.userInfo.access_token,
              };
              const routeData = this.$router.resolve({
                name: `print`,
                query: obj,
              });
              window.open(routeData.href);
              this.handleClose();
            }
          });
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .formClass {
    padding: 20px;
  }

  .bank-style {
    height: 28px;
    padding-left: 10px;
  }
  ::v-deep .el-dialog-footer {
    text-align: center;
  }
</style>
